import { __assign, __rest } from "tslib";
import React from "react";
import { SelectMultiple } from "./SelectMultiple";
import { NativeSelect } from "./NativeSelect";
import { SimulateSelect } from "./SimulateSelect";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var Select = forwardRefWithStatics(function Select(_a, ref) {
    var type = _a.type, props = __rest(_a, ["type"]);
    // 兼容早期原生下拉选择
    if (type === "native") {
        return React.createElement(NativeSelect, __assign({ ref: ref }, props));
    }
    return React.createElement(SimulateSelect, __assign({ ref: ref }, props));
}, {
    Multiple: SelectMultiple,
    defaultLabelAlign: "middle",
});
Select.displayName = "Select";
